import React from 'react';

export default function MainParticipantInfo({ participant, children }) {  
    return (
        <div className="main-participant-info" data-cy-main-participant>            
            {children}
        </div>
  );
}
